import type { Account } from "./types";

const MAX_MODEL_ALIASES = new Set([
  "videos-max",
  "seedance-2.0-max",
  "seedance-2-max",
  "seedance_2_0_max",
]);

export function supportsVideosMax(account: Pick<Account, "supported_models">): boolean {
  return (account.supported_models || []).some((model) => MAX_MODEL_ALIASES.has(model.trim().toLowerCase()));
}

export function maxFreeGenerationQuotaText(
  account: Pick<Account, "supported_models" | "free_generation_quotas">,
): string | null {
  if (!supportsVideosMax(account)) return null;

  const quota = account.free_generation_quotas?.["videos-max"];
  if (typeof quota !== "number" || !Number.isFinite(quota) || quota < 0) {
    return "Max 免费额度 -";
  }
  return `Max 免费额度 ${quota.toLocaleString("zh-CN")} 条`;
}
